/** A leading URI scheme, e.g. `https:` or `javascript:`. */
const SCHEME = /^([a-z][a-z0-9+.-]*):/i;
/** What follows `host:` when it is a port rather than a scheme, e.g. `example.com:8080/x`. */
const PORT_REMAINDER = /^\d+(?:[/?#]|$)/;
const LINKABLE_PROTOCOLS = new Set(['http:', 'https:']);
/** A top-level domain: two letters or more, or an IDN in punycode — as the API's URL check. */
const TOP_LEVEL_DOMAIN = /^(?:[a-z]{2,}|xn--[a-z0-9-]{2,})$/i;

/**
 * The address a stored website may link to: http(s) only, `https://` added when the scheme is
 * missing, `null` for any other scheme or a value that is not a web address.
 */
export function toWebsiteHref(website: string | null | undefined): string | null {
  const value = website?.trim();
  if (!value || /\s/.test(value)) return null;

  const scheme = SCHEME.exec(value);
  const hasScheme = scheme !== null && !PORT_REMAINDER.test(value.slice(scheme[0].length));
  const candidate = hasScheme ? value : `https://${value}`;

  let url: URL;
  try {
    url = new URL(candidate);
  } catch {
    return null;
  }
  if (!LINKABLE_PROTOCOLS.has(url.protocol)) return null;
  // Credentials in a link disguise its real host (`https://bank.cz@evil.example`).
  if (url.username || url.password) return null;
  const labels = url.hostname.split('.');
  if (labels.length < 2 || !TOP_LEVEL_DOMAIN.test(labels.at(-1) ?? '')) return null;
  return url.href;
}
